export default "__VITE_ASSET__3126e000__"